module.exports = __webpack_public_path__ + "static/media/icons-adults.b1f79054.svg";